import { Box, Typography } from '@mui/material';
import { AddCircleOutlineOutlined as AddIcon } from '@mui/icons-material';

import LinkedServicesIcon from '../../../../../components/svgs/LinkedServicesIcon';
import { FORTA_BLUE, FORTA_SKY_BLUE_3 } from '../../../../../utils/colors';

interface GoalItemProps {
  id: number | string;
  label: string;
  onSelect: (id: number | string) => void;
}

const SuggestedGoal = ({ id, label, onSelect }: GoalItemProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: `1px solid ${FORTA_BLUE.primary}`,
        backgroundColor: FORTA_SKY_BLUE_3,
        borderRadius: '10px',
        padding: '10px',
        cursor: 'pointer',
        minWidth: 'fit-content',
      }}
      onClick={() => onSelect(id)}
    >
      <Box sx={{ mb: -1, mr: 1 }}>
        <LinkedServicesIcon />
      </Box>

      <Box sx={{ minWidth: '80%', flexGrow: 1 }}>
        <Typography noWrap fontWeight={500}>
          {label}
        </Typography>
      </Box>
      <Box sx={{ mb: -1, ml: 1 }}>
        <AddIcon style={{ color: FORTA_BLUE.primary, width: 28, height: 28 }} />
      </Box>
    </Box>
  );
};

export default SuggestedGoal;
